import { google, ics, office365, yahoo } from "calendar-link";

import createEvent from "../utilities/calendar-event";

const CALENDAR_OPTIONS = [
  {
    name: "Apple",
    icon: "fa-apple",
    createHref: openHouseData => ics(createEvent(openHouseData)),
    isSelfTarget: true
  },
  {
    name: "Google.com",
    icon: "fa-google",
    createHref: openHouseData => google(createEvent(openHouseData))
  },
  {
    name: "Office 365",
    icon: "fa-calendar-o",
    createHref: openHouseData => office365(createEvent(openHouseData))
  },
  {
    name: "Yahoo.com",
    icon: "fa-yahoo",
    createHref: openHouseData => yahoo(createEvent(openHouseData))
  }
];

export default CALENDAR_OPTIONS;
